// extracted by mini-css-extract-plugin
export default {"root":"_35qel","text":"_39cl5","icon":"dU6QG"};